/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import Button from '@material-ui/core/Button';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  t: TranslatorProps,
  actionDrawerStore: TypeActionDrawerStore,
  asset: Object,
};

@translate()
@inject('actionDrawerStore')
@observer
export default class ReportAssetFaultError extends React.Component<*> {
  render(): React.Element<*> {
    const { t, actionDrawerStore, asset }: TypeProps = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div>
            <h3>{t('general:error')}</h3>
            <p>{t('general:assets.owned_assets.messages.fault_report_error')}</p>
          </div>
          <div className={styles['archive-account-details']}>
            <div>
              {t('general:assets.labels.number')}: {asset.asset_number}
            </div>
          </div>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
